const PHASE1_ROUTE_SLUGS = [
  "le-havre-rouen", "le-havre-caen", "le-havre-dieppe", "le-havre-paris",
  "le-havre-bretagne", "caen-rouen", "rouen-paris", "caen-paris",
];

const RAW_ROUTES = [
  { slug: "le-havre-rouen", fromSlug: "le-havre", toSlug: "rouen" },
  { slug: "le-havre-caen", fromSlug: "le-havre", toSlug: "caen" },
  { slug: "le-havre-dieppe", fromSlug: "le-havre", toSlug: "dieppe" },
  { slug: "le-havre-paris", fromSlug: "le-havre", toSlug: "paris" },
  { slug: "le-havre-rennes", fromSlug: "le-havre", toSlug: "rennes" },
  { slug: "le-havre-lille", fromSlug: "le-havre", toSlug: "lille" },
  { slug: "le-havre-bretagne", fromSlug: "le-havre", toSlug: "bretagne" },
  { slug: "le-havre-ile-de-france", fromSlug: "le-havre", toSlug: "ile-de-france" },
  { slug: "rouen-caen", fromSlug: "rouen", toSlug: "caen" },
  { slug: "caen-rouen", fromSlug: "caen", toSlug: "rouen" },
  { slug: "rouen-paris", fromSlug: "rouen", toSlug: "paris" },
  { slug: "rouen-dieppe", fromSlug: "rouen", toSlug: "dieppe" },
  { slug: "rouen-ile-de-france", fromSlug: "rouen", toSlug: "ile-de-france" },
  { slug: "caen-le-havre", fromSlug: "caen", toSlug: "le-havre" },
  { slug: "caen-paris", fromSlug: "caen", toSlug: "paris" },
  { slug: "caen-bretagne", fromSlug: "caen", toSlug: "bretagne" },
];

export const ROUTES = RAW_ROUTES.map((r) => ({ ...r, isPhase1: PHASE1_ROUTE_SLUGS.includes(r.slug) }));

export function getRouteBySlug(slug) {
  return ROUTES.find((r) => r.slug === slug);
}

export function getPhase1Routes() {
  return ROUTES.filter((r) => r.isPhase1);
}

export function findRouteBetween(fromSlug, toSlug) {
  return ROUTES.find(
    (r) => (r.fromSlug === fromSlug && r.toSlug === toSlug) || (r.fromSlug === toSlug && r.toSlug === fromSlug)
  );
}
